import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPaymentMethods,
  fetchPaymentMethodById,
  clearSelectedMethod,
} from "../../RTK/Payment-methods/GetAllPaymentMMethods";
import {
  CreditCard,
  AlertCircle,
  CheckCircle2,
  Settings,
  X,
  Plus,
  Lock
} from "lucide-react";
import PaymentMethodModal from "./popups/PaymentMethodModal";
import CreatePaymentMethodModal from "./popups/CreatePaymentMethodModal";
import { toast } from "react-toastify"; 
import { usePermissions } from "../../contexts/PermissionsContext";
const PaymentMethodsPage = () => {
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions(); 
  
  // ✅ فحص الصلاحية
  const canManagePaymentMethods = hasPermission("manage_payment_methods");
  const [showCreateModal, setShowCreateModal] = useState(false);


  const {
    items: paymentMethods,
    selectedMethod,
    status,
    error,
  } = useSelector((state) => state.paymentMethods);

  useEffect(() => {
    dispatch(fetchPaymentMethods());
  }, [dispatch]);



  const handleMethodClick = (id) => {
    if (!canManagePaymentMethods) {
      toast.error("ليس لديك صلاحية لعرض تفاصيل طرق الدفع 🔒");
      return;
    }
    dispatch(fetchPaymentMethodById(id));
  };

  const handleCreateClick = () => {
    if (!canManagePaymentMethods) {
      toast.error("ليس لديك صلاحية لإضافة طرق دفع جديدة 🔒");
      return;
    }
    setShowCreateModal(true);
  };

  const handleCloseModal = () => {
    dispatch(clearSelectedMethod());
  };

  if (status === "loading") {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }



return (
    <div className="container mx-auto px-4 py-8" dir="rtl">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-100">طرق الدفع</h1>
        
        {/* ✅ زر إضافة - محمي */}
        {canManagePaymentMethods ? (
          <button
            onClick={handleCreateClick}
            className="flex items-center gap-2 px-4 py-2 bg-green-500 text-white rounded-xl hover:bg-green-600 transition-colors"
          >
            <Plus className="w-4 h-4" />
            إضافة
          </button>
        ) : (
          <div className="flex items-center gap-2 px-4 py-2 bg-slate-800/50 rounded-xl border border-slate-700">
            <Lock className="w-4 h-4 text-slate-500" />
            <span className="text-slate-400 text-sm">
              ليس لديك صلاحية
            </span>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {paymentMethods.map((method) => (
          <div
            key={method.id}
            onClick={() => handleMethodClick(method.id)}
            className={`bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700 transition-all duration-300 relative ${
              canManagePaymentMethods
                ? "hover:border-primary/50 cursor-pointer"
                : "opacity-70 cursor-not-allowed"
            }`}
          >
            {/* ✅ أيقونة قفل لو مافيش صلاحية */}
            {!canManagePaymentMethods && (
              <div className="absolute top-2 left-2 bg-slate-700/90 p-1.5 rounded-lg z-10">
                <Lock className="w-3 h-3 text-slate-400" />
              </div>
            )}

            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-gray-700/50 p-2 flex items-center justify-center">
                  <img
                    src={method.provider_image}
                    alt={method.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white">
                    {method.name}
                  </h3>
                  <p className="text-sm text-gray-400">{method.provider}</p>
                </div>
              </div>
              {method.is_active ? (
                <CheckCircle2 className="w-5 h-5 text-green-500" />
              ) : (
                <AlertCircle className="w-5 h-5 text-yellow-500" />
              )}
            </div>

            <div className="space-y-3">
              <div className="bg-gray-700/30 rounded-xl p-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-400">الرسوم</span>
                  <span className="text-white font-semibold">
                    {method.fee_percentage}%
                  </span>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <span className="text-gray-400">الحد الأدنى للإيداع</span>
                  <span className="text-white font-semibold">
                    ${method.minimum_deposit_amount}
                  </span>
                </div>
              </div>

              <div className="bg-gray-700/30 rounded-xl p-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-400">سعر العملة</span>
                  <span className="text-white font-semibold">
                    ${method.currency_price}
                  </span>
                </div>
              </div>

              <div className="flex gap-2 mt-4">
                <span
                  className={`px-3 py-1 rounded-full text-xs ${
                    method.is_automatic
                      ? "bg-green-500/20 text-green-400"
                      : "bg-yellow-500/20 text-yellow-400"
                  }`}
                >
                  {method.is_automatic ? "تلقائي" : "يدوي"}
                </span>
                <span className="bg-blue-500/20 text-blue-400 px-3 py-1 rounded-full text-xs">
                  {method.payment_method_account_type}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ Modal يظهر فقط لو عنده صلاحية */}
      {selectedMethod && canManagePaymentMethods && (
        <PaymentMethodModal
          method={selectedMethod}
          onClose={handleCloseModal}
        />
      )}

      {showCreateModal && canManagePaymentMethods && (
        <CreatePaymentMethodModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
        />
      )}
    </div>
  );
};

export default PaymentMethodsPage;
